
import { DeliveryOption } from "@/components/payment/DeliveryOption"
import { DeliveryOption as DeliveryOptionType } from "@/data/deliveryOptions"

interface PaymentDeliverySelectorProps {
  deliveryOptions: DeliveryOptionType[]
  selectedOption: string | null
  onSelect: (id: string) => void
}

export function PaymentDeliverySelector({ 
  deliveryOptions, 
  selectedOption, 
  onSelect 
}: PaymentDeliverySelectorProps) {
  return (
    <div className="space-y-4">
      {deliveryOptions.map((option) => (
        <DeliveryOption
          key={option.id}
          {...option}
          selected={selectedOption === option.id}
          onSelect={onSelect}
        />
      ))}
    </div>
  )
}
